import { PayloadAction } from '../../../../store.model';
import { TaskItem } from '../../../core';
import { groups } from '../const/view-groups.const';
import { filterItems } from '../function/filter-items.function';
import { groupItems } from '../function/group-items.function';
import { ActionType } from '../task-list-dialog.action';
import { TaskListDialogState } from '../task-list-dialog.state';
import { taskItemTransformer } from '../transformer/task-item.transformer';
import { viewTaskItemTransformer } from '../transformer/view-task-item.transformer';

import { UpdateItem } from './update-item.action';

export function updateItemReducer(
    state: TaskListDialogState,
    action: PayloadAction<ActionType, UpdateItem>,
): TaskListDialogState {
    try {
        const item = taskItemTransformer([action.payload.task])[0];

        const nextItems = state.tasks.map<TaskItem>((t) => {
            if (t.msftTaskId === action.payload.task.msftTaskId) {
                return item;
            }
            return t;
        });

        const nextViewItems = viewTaskItemTransformer(nextItems);

        const nextFilt = filterItems({
            items: nextViewItems,
            filterOpts: state.filterOpts,
            orderBy: state.orderBy,
        });

        const nextGroups = groupItems(groups, nextFilt);

        nextViewItems.forEach((t, ti) => {
            if (t.msftTaskId === action.payload.task.msftTaskId) {
                nextViewItems[ti] = {
                    ...t,
                    // yes, retain 'editing'
                    editing: t.editing,
                };
            }
        });

        return {
            ...state,
            tasks: nextItems,
            groups: nextGroups,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
